import { ClipboardCheck, ExternalLink } from "lucide-react";
import { SectionCard } from "@/components/report/SectionCard";
import { StatusNotice } from "@/components/report/StatusNotice";
import { useLang } from "@/lib/i18n";

const fmtInspDate = (v) => {
  if (!v) return "—";
  const s = String(v).trim();
  const m = s.match(/^(\d{4})(\d{2})(\d{2})$/);
  return m ? `${m[1]}-${m[2]}-${m[3]}` : s;
};

export const InspectionsSection = ({ report, lang }) => {
  const { t } = useLang();
  const block = report.inspections || { status: "unavailable", items: [] };
  const items = block.items || [];
  const lookup = block.official_lookup;

  return (
    <SectionCard icon={ClipboardCheck} title={t("sec.inspections")} testid="section-inspections">
      {block.status !== "ok" ? (
        <StatusNotice status="unavailable" testid="inspections-unavailable" />
      ) : items.length === 0 ? (
        <StatusNotice status="none" testid="inspections-none" />
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full border-collapse text-sm">
            <thead>
              <tr className="border-b border-border text-left font-mono text-[10px] uppercase tracking-wider text-muted-foreground">
                <th className="py-2 pr-3 font-medium">{t("insp.permit")}</th>
                <th className="py-2 font-medium">{t("insp.lastDate")}</th>
              </tr>
            </thead>
            <tbody>
              {items.map((it, i) => (
                <tr key={`${it.permit_number}-${i}`} data-testid="inspection-row" className="border-b border-border/60 last:border-0">
                  <td className="py-3 pr-3 font-mono text-xs font-semibold text-foreground">{it.permit_number}</td>
                  <td className="py-3 font-mono text-xs text-muted-foreground">{fmtInspDate(it.last_inspection_date)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <p className="mt-3 text-xs leading-relaxed text-muted-foreground" data-testid="inspections-note">{block.note}</p>
      {lookup?.url && (
        <a href={lookup.url} target="_blank" rel="noopener noreferrer"
           className="mt-2 inline-flex items-center gap-1 text-[11px] font-medium text-primary hover:underline">
          {t("insp.lookup")} <ExternalLink className="h-3 w-3" />
        </a>
      )}
    </SectionCard>
  );
};
